// extracted by mini-css-extract-plugin
module.exports = {"back":"back_back__32OTt","close":"back_close__2WNGf","white":"back_white__AbO1N"};